var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { IdentifiableMap } from "../../collections";
import { makeImmutable } from "../../core";
import { perRestaurant } from "../../di";
import { ModifierInstanceFactory, } from "../ProductInstance";
import { ModifierInstanceCreatorFactory } from "./ModifierInstanceCreatorFactory";
import { ProductInstanceCreatorPart } from "./ProductInstanceCreatorPart";
let ProductInstanceCreatorPartFactory = class ProductInstanceCreatorPartFactory {
    constructor(modifierInstanceCreatorFactory, modifierInstanceFactory) {
        this.modifierInstanceCreatorFactory = modifierInstanceCreatorFactory;
        this.modifierInstanceFactory = modifierInstanceFactory;
        makeImmutable(this);
    }
    create(part, creatorScopeProvider) {
        const modifierInstanceCreators = IdentifiableMap.fromIterable("typeId", part.productType.divisibleModifierTypes.objects.map((modifierType) => {
            const initialInstance = part.modifierInstances.find(modifierType.id);
            const modifierSettings = part.productType.modifierSettings(modifierType);
            return this.modifierInstanceCreatorFactory.create({
                modifierInstance: initialInstance !== null && initialInstance !== void 0 ? initialInstance : this.modifierInstanceFactory.createWithDefaultItems({
                    modifierType,
                    modifierSettings,
                }),
                modifierSettings,
                creatorScopeProvider,
            });
        }));
        return new ProductInstanceCreatorPart({
            productType: part.productType,
            modifierInstanceCreators,
        });
    }
};
ProductInstanceCreatorPartFactory = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof ModifierInstanceCreatorFactory !== "undefined" && ModifierInstanceCreatorFactory) === "function" ? _a : Object, typeof (_b = typeof ModifierInstanceFactory !== "undefined" && ModifierInstanceFactory) === "function" ? _b : Object])
], ProductInstanceCreatorPartFactory);
export { ProductInstanceCreatorPartFactory };
